import { useUserStore } from "~/stores/user";

export async function initUserOnClient(context) {
  const userStore = useUserStore(context.$pinia);

  if (userStore.meLoaded) {
    await userStore.updateLastPerson();
  }
}
